export default "__VITE_ASSET__CLe_B3fJ__"